import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext } from 'react';
// import { useHistory } from 'react-router';
// import { Link } from 'react-router-dom';
// import { uid } from 'uid';
import { IoCloseSharp } from 'react-icons/io5';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
// import axios from 'axios';
import { OptionTypeBase } from 'react-select';
import { geocodeByPlaceId } from 'react-google-places-autocomplete';
import TextInput from '../../../form-controls/TextInput';
import { PropsFromRedux } from '.';
import { getRequiredErrorMessage } from '../../../../utils/common.utils';
import { PhoneNumberInput, PhoneValue } from '../../../form-controls/PhoneNumberInput';
import { validatePhoneNumber } from '../../../../utils/phone.utils';
import LocationInput from '../../../form-controls/PlacesAutocomplete';
import PersonalShopperContext from '../../../../context/PersonalShopperContex/PersonalShopperContex';
import { getAddressComponent } from '../../../ShippingForm/shippingform.utils';

import { STATION } from '../../../../interfaces/shipping.interface';


interface Props extends PropsFromRedux {}

interface Inputs {
    ReceiverName: string;
    Address : string;
    State : string;
    PhoneNumber : PhoneValue;
    Email : string;
}

const schema = yup.object().shape({
    Address: yup
      .string()
      .required(getRequiredErrorMessage("Receiver's address")),
    ReceiverName: yup.string().required(getRequiredErrorMessage("Receiver's name")),
    Email: yup.string()
    .email()
    .required(getRequiredErrorMessage("Email")),
    State: yup.string().required(getRequiredErrorMessage("State")),
    PhoneNumber: yup
      .object()
      .shape({
        country: yup.string().required('Country code is required'),
        phoneNumber: yup
          .string()
          .max(15, 'Invalid phone number length')
          .required('Phone number is required')
          .typeError('Enter a valid phone number'),
      })
      .required(getRequiredErrorMessage('Phone Number'))
      .test('Validate-phone', 'Enter a valid phone number', validatePhoneNumber),
  });



  export const ReceiverDetails: React.FC<Props> = ({
    showModal,
    hideModal,
    locations
  }) => {
const [destination, setDestination] = React.useState<any>();

const { shopperData, setShopperData } = useContext(PersonalShopperContext);

const stations: STATION[] = locations?.response?.Object || [];
const [destinationData, setDestinationData] = React.useState<
google.maps.GeocoderResult[] | null
>(null);
const [state, setReceiverState] = React.useState<any>();


const closeModal = () => {
        hideModal();
 };

const onSubmit = async (data: Inputs) => {
    const shoppingDetails  = shopperData;
    const rec = {
        FullName : data.ReceiverName,
        Address : data.Address,
        PhoneNumber : data.PhoneNumber.phoneNumber,
        // State: state,
        Email: data.Email,
        // "DestinationServiceCentreId": receiverList[0].DestinationServiceCentreId,
        // "DepartureServiceCentreID": "chinaservicecenterid" ,
        "StationId" : null
    }
    shoppingDetails.Receiver = rec
    setShopperData(shoppingDetails);
    hideModal();
}

// console.log('I got to this page');


React.useEffect(() => {
    async function fetchData() {
      const geocode = await geocodeByPlaceId(destination);
      setDestinationData(geocode);
    }
    if (destination) {
      fetchData();
    }
    

  }, [destination]);

React.useEffect(() => {
    // console.log('destination data',destinationData);
    if (destinationData) {
    const receiverState : any = getAddressComponent(destinationData, 'administrative_area_level_1')?.long_name;
    const selectedState = receiverState.toUpperCase();
    // console.log('selected state', selectedState);
    const stationObj : any = stations.find( ( station : any ) => station.StationName === selectedState );
    setReceiverState(receiverState);
    
if(stationObj !== undefined){
    setReceiverState(stationObj);
}
setValue('State', stationObj.StationName);

// console.log('State Name', stationObj.StationName);
} }, [destinationData]);

const { handleSubmit, control, errors, reset, watch,register, setValue } = useForm<Inputs>({
    resolver: yupResolver(schema),
});


return(
    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
     <div className="w-full sm:px-12 px-12 bg-white lg:px-36 py-10 relative">
            <button type="button" aria-label="Close" onClick={closeModal}>
                <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
            </button> 
            <h2 className="font-semibold mb-4 text-3xl text-black text-center my-6 mb-4">Receiver Details</h2>
            <div className="w-full mb-5 text-sm text-gray-500 font-medium">
                    <Controller
                        name="ReceiverName"
                        control={control}
                        defaultValue=""
                        render={({ name, value, onChange }) => (
                            <TextInput
                                name={name}
                                value={value}
                                className="w-full border-gray-300 border p-3 w-full rounded-md"
                                id={name}
                                labelClassName="mb-2 flex "
                                label="Receiver's Name"
                                type="string"
                                wrapperClassName="w-full"
                                error={errors['ReceiverName']}
                                placeholder="Receiver's Name"
                                customChange={onChange}
                            />
                        )}
                     />
            </div>
            <div className="mb-5 text-sm text-gray-500 font-medium ">
                     <Controller
                            name="Address"
                                    control={control}
                                    defaultValue=""
                                    render={({ name, value, onChange }) => (
                                    <LocationInput
                                        name={name}
                                        value={value}
                                        className="w-full mr-1 p-2 "
                                        id={name}
                                        labelClassName="flex ml-2 text-sm text-gray-500 font-medium"
                                        label="Address"
                                        wrapperClassName="w-full"
                                        error={errors['Address']}
                                        placeholder="Address"
                                        customChange={(locationValue: OptionTypeBase) => {
                                            setDestination(locationValue?.value.place_id);
                                            onChange(locationValue?.label);
                                        }}
                                    />
                                )}
                        />
            </div>
            <div className="mb-5 text-sm text-gray-500 font-medium ">
                 <Controller
                                    name="State"
                                    control={control}
                                    defaultValue=""
                                    render={({ name, value, onChange }) => (
                                    <TextInput
                                        name={name}
                                        value={value}
                                        className="border-gray-300 border p-3 w-full rounded-md"
                                        id={name}
                                        labelClassName="mb-2 flex ml-6 text-sm text-gray-500 font-medium"
                                        label="State"
                                        type="string"
                                        disabled
                                        wrapperClassName="w-full"
                                        error={errors['State']}
                                        placeholder="State"
                                        customChange={onChange}
                                    />
                                )}
                             />
            </div>
            <div className="mb-5 text-sm text-gray-500 font-medium">
                 <Controller
                        name="Email"
                        control={control}
                        defaultValue=""
                        render={({ name, value, onChange }) => (
                        <TextInput
                            name={name}
                            value={value}
                            className="border-gray-300 border mr-1 p-2 w-full rounded"
                            id={name}
                            labelClassName="mb-2 flex ml-2 text-sm text-gray-500 font-medium"
                            label="Email Address"
                            type="string"
                            wrapperClassName="w-full"
                            error={errors['Email']}
                            errorClassName="absolute -mt-6 ml-6 "
                            placeholder=""
                            customChange={onChange}
                        />
                        )}
                    />
            </div>
            <div className="mb-5 text-sm text-gray-500 font-medium">
            <Controller
                    name="PhoneNumber"
                    control={control}
                    defaultValue=""
                    
                    render={({ name, value, onChange }) => (
                        <PhoneNumberInput
                        name={name}
                        value={value}
                        id={name}
                        inputClassName="h-full w-full border-l rounded-l-none rounded-md border-gray-300 p-3"
                        international
                        appendStyles
                        labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
                        label="Phone Number:"
                        className="w-full"
                        wrapperClassName="w-full"
                        error={
                            errors['PhoneNumber']?.phoneNumber ||
                            errors['PhoneNumber']?.country ||
                            errors['PhoneNumber']
                        }
                        placeholder="Phone Number"
                        customChange={onChange}
                        />
                    )}
                    />
            </div>
            {/* <div className="mb-4 w-full">
            <label className="text-sm" htmlFor="save_receiver">
              <input
                name="save_receiver"
                type="checkbox"
                id="save_receiver"
                className="mr-2 text-xl"
                ref={register}
              />
              Save this receiver for future use{' '}
            </label>
          </div> */}
          <div className="w-full flex justify-center">
            <button
                className="w-full bg-secondary my-10 font-semibold text-sm rounded text-white py-4"
                type="submit"
                // disabled={validationState?.loading}
                >
                    Continue
            </button>
        </div>
        </div>
    </form>
);  

}